import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const LinkedinAd = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12730"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12730)">
          <rect
            x="-3"
            width="121"
            height="112"
            rx="5.09677"
            fill="#BFCDFF"
          />
          <rect
            x="10.0664"
            y="28.0625"
            width="26.4395"
            height="43.004"
            rx="4.61895"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="18.0176"
            y="30.7703"
            width="11.239"
            height="1.27419"
            rx="0.637097"
            fill="#1E1E1E"
          />
          <rect
            x="19.6228"
            y="38.2561"
            width="57.6573"
            height="50.6492"
            rx="0.796371"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="19.145"
            y="62.625"
            width="58.6129"
            height="1.27419"
            fill="#1E1E1E"
          />
          <rect
            x="19.145"
            y="42.875"
            width="58.6129"
            height="0.955645"
            fill="#1E1E1E"
          />
          <rect
            x="23.6047"
            y="53.0686"
            width="49.0564"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <rect
            x="23.6047"
            y="57.5283"
            width="38.8629"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <rect
            x="31.25"
            y="47.9718"
            width="12.1048"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <circle
            cx="26.1531"
            cy="48.6089"
            r="2.54839"
            fill="#8C8C8C"
          />
          <circle
            cx="68.5201"
            cy="40.6452"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="71.7056"
            cy="40.6451"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="74.8909"
            cy="40.6451"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="52.9113"
            cy="70.9074"
            r="1.91129"
            fill="#0C5CEF"
          />
          <path
            d="M45.4549 70.0025C45.5184 69.9133 45.6509 69.9133 45.7144 70.0025L56.2655 84.831C56.3405 84.9365 56.2651 85.0827 56.1357 85.0827H35.0336C34.9042 85.0827 34.8288 84.9365 34.9038 84.831L45.4549 70.0025Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <path
            d="M54.6934 75.0875C54.757 74.9995 54.8881 74.9995 54.9517 75.0875L55.3341 74.8113L54.9517 75.0875L61.9879 84.83C62.064 84.9354 61.9887 85.0826 61.8588 85.0826H47.7863C47.6564 85.0826 47.5811 84.9354 47.6572 84.83L54.6934 75.0875Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="72.502"
            y="20.4174"
            width="33.4476"
            height="33.4476"
            rx="16.7238"
            fill="white"
          />
          <rect
            x="72.502"
            y="20.4174"
            width="33.4476"
            height="33.4476"
            rx="16.7238"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <path
            d="M85.4343 43.4184H82.5301V34.2917H85.4343V43.4184ZM91.4638 36.974C91.1247 36.974 90.7994 37.1072 90.5596 37.3443C90.3197 37.5814 90.185 37.903 90.185 38.2383V43.4184H87.1314V34.2917H90.185V35.2311C90.9007 34.6321 91.8049 34.2979 92.7426 34.2858C94.6369 34.2858 95.9516 35.6742 95.9516 38.3092V43.4184H92.7426V38.2383C92.7434 38.0718 92.7109 37.9067 92.647 37.7526C92.5831 37.5986 92.489 37.4585 92.3702 37.3405C92.2514 37.2224 92.1101 37.1288 91.9546 37.0649C91.799 37.001 91.6323 36.9681 91.4638 36.9681V36.974ZM85.4881 31.444C85.4881 31.7362 85.4005 32.0217 85.2363 32.2646C85.0722 32.5075 84.8389 32.6968 84.5659 32.8086C84.2929 32.9204 83.9925 32.9497 83.7027 32.8927C83.4129 32.8357 83.1467 32.695 82.9378 32.4885C82.7289 32.2819 82.5866 32.0187 82.529 31.7322C82.4713 31.4457 82.5009 31.1487 82.614 30.8788C82.727 30.6089 82.9185 30.3783 83.1642 30.216C83.4099 30.0537 83.6987 29.967 83.9942 29.967C84.3883 29.9702 84.7652 30.1271 85.0428 30.4038C85.3204 30.6805 85.4762 31.0544 85.4761 31.444H85.4881Z"
            fill="#0A66C2"
            stroke="#0A66C2"
            strokeWidth="0.179351"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SvgIcon>
    );
  })
);
